// extracted by mini-css-extract-plugin
module.exports = {"modalDialog":"Modal_modalDialog__12mjw","modal-content":"Modal_modal-content__B6ScF","modalHeader":"Modal_modalHeader__3OnpY","modalBody":"Modal_modalBody__3HWyX"};